/*
Ashraf 12/09/2022 2698947782  reusable notes form
Raghuarun 12/20/2022 2698947782 fixed text field and button alignments
Ashraf 12/09/2022 2698947782 reusable notes form
kavyareddy 12/20/2022 2698947782 Added dropdown for createdBy and noteType
Raghuarun 12/21/2022 2698947782 text feild alignments
Raghu 12/23/2022 2698947782 Responsive Field Alignments
kavyareddy 12/23/2022 2698947782 Fixed createdBy issue
Prakash 02/13/2023 2698403495 Added New UI Style-classes for Fields and Buttons.
Prakash 02/16/2023 2698403495 Fixed UI-Bug.
Dilip 02/20/2023 3225736869 added created by dropdown
Dilip 02/21/2023 3225736869 changed created by dropdown
suresh peddavoora 02/27/2023 3225736869 New UI changes
Prakash 03/21/2023 2698403495 Fixed alignments issue.
Prakash 04/06/2023 2698403495 Fixed alignments issue.
Prakash 15-05-2023 2698403495 Fixed alignments issue in tab view.
Akhila 06/06/2023 2698403495 added code and description in action
Akhila 06/07/2023 2698403495 Added code and description
Sohel 10/19/2023 2698403495 Fixed Created By Dropdown Issue
Sohel 11/07/2023 2698403495 userMangement username removed from breadCrums
Gireesh 12/12/2023 2698403495 Renamed Data Calculation Code to name  
*/
import React, {useEffect, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, TextField} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../themes/ThemeProvider';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import {
  fetchCreatedByDropDownData,
  getAllReportCreatedForData,
} from '../../redux/reducers/ReportMaster';
import BreadCrums from '../../util/BreadCrum';
import {createdByOptions} from '../../util/CreatedByForOptions';

const SearchNote = ({
  setSearchData,
  searchData,
  submit,
  setSubmit,
  dmrData,
  type,
  imrgData,
  dmData,
  ediData,
  triggerData: repository,
  filedListCode: repositoryField,
  AuditFieldListCode,
  formulaCodeData: DataCalculationData,
  filterData: FilterRuleData,
  triggerDataBR: triggerData,
  reportCodeData,
  workQueue,
  schedulerData,
  workQueueCodeData,
  roleName: roleManagementData,
  userLoginName: UserManagementData,
  moduleName,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);

  const noteTypeOptions = [
    {key: 'User', value: 'User'},
    {key: 'Sys', value: 'Sys'},
  ];

  const initialValues = {
    noteType: '',
    noteDate: null,
    noteText: '',
    createdBy: '',
  };

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedByDropDownData(moduleName));
  }, []);

  // useEffect(() => {
  //   dispatch(fetchCreatedByDropDownData("datacalculation"));
  // }, [dispatch]);

  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };

  return (
    <div className="">
      <Formik onSubmit={handleSubmit} initialValues={initialValues} enableReinitialize>
        {(props) => {
          const {
            values,
            handleChange,
            handleBlur,
            setFieldValue,
            touched,
            errors,
            resetForm,
          } = props;

          return (
            <div>
              <Form autoComplete="off">
                <ErrorBoundaryForComponents>
                  {(type ||
                    triggerData ||
                    repository ||
                    repositoryField ||
                    AuditFieldListCode ||
                    DataCalculationData ||
                    FilterRuleData ||
                    reportCodeData ||
                    workQueue ||
                    schedulerData ||
                    roleManagementData ||
                    UserManagementData) && (
                    <div className="form-row">
                      <div className=" col-md-12 mb-1">
                        <BreadCrums
                          name={
                            repository || repositoryField ?
                              'Repository Name' :
                              roleManagementData ?
                                'Role Name' :
                                UserManagementData ?
                                  'User Login Name' :             
                                  'Name'
                            // type === "Export"
                            //   ? "Export Template Record Code" :  "Import Template Record Code"
                          }
                          code={
                            dmrData?.recordCode?.replace(/ /g, '\u00a0') ||
                            imrgData?.groupCode?.replace(/ /g, '\u00a0') ||
                            dmData?.dmCode?.replace(/ /g, '\u00a0') ||
                            ediData?.exportCode?.replace(/ /g, '\u00a0') ||
                            repository?.repositoryName?.replace(/ /g, '\u00a0') ||
                            repositoryField?.repositoryName?.replace(/ /g, '\u00a0') ||
                            AuditFieldListCode?.fieldListCode?.replace(/ /g, '\u00a0') ||
                            DataCalculationData?.code?.replace(/ /g, '\u00a0') ||
                            FilterRuleData?.code?.replace(/ /g, '\u00a0') ||
                            triggerData?.code?.replace(/ /g, '\u00a0') ||
                            reportCodeData?.reportCode?.replace(/ /g, '\u00a0') ||
                            schedulerData?.jobCode?.replace(/ /g, '\u00a0') ||
                            roleManagementData?.roleName?.replace(/ /g, '\u00a0') ||
                            UserManagementData?.userLoginName?.replace(/ /g, '\u00a0') ||
                            workQueueCodeData?.workqueueName
                          }
                          description={
                            roleManagementData ?
                              'Role Description' :
                              UserManagementData ?
                                '' : 
                                'Description'
                          }
                          // description=
                          // {
                          // type === "Export"
                          //   ? "Export Template Record Code Description" :"Import Template Record Description"
                          // }
                          descriptionValue={
                            triggerData?.description?.replace(/ /g, '\u00a0') ||
                            dmrData?.recordDescription?.replace(/ /g, '\u00a0') ||
                            dmData?.dmDescription?.replace(/ /g, '\u00a0') ||
                            ediData?.exportDescription?.replace(/ /g, '\u00a0') ||
                            repository?.repositoryDescription?.replace(/ /g, '\u00a0') ||
                            imrgData?.groupDescription?.replace(/ /g, '\u00a0') ||
                            repositoryField?.repositoryDescription?.replace(/ /g, '\u00a0') ||
                            AuditFieldListCode?.fieldListDesc?.replace(/ /g, '\u00a0') ||
                            DataCalculationData?.description?.replace(/ /g, '\u00a0') ||
                            FilterRuleData?.description?.replace(/ /g, '\u00a0') ||
                            reportCodeData?.reportDescription?.replace(/ /g, '\u00a0') ||
                            schedulerData?.jobDescription?.replace(/ /g, '\u00a0') ||
                            roleManagementData?.roleDescription?.replace(/ /g, '\u00a0') ||
                            workQueueCodeData?.workqueueDescription
                          }
                        />
                      </div>
                    </div>
                  )}

                  <div className="form-row  new-standard-textfields standard-field-textfields">
                    {/* <div className="col-sm-6 col-xs-6 col-md-2 col-xl-2 col-lg-2 form-group">
                      <TextField
                        margin="dense"
                        className={`${classes.labelName} ${classes.inputLabel}`}
                        variant="standard"
                        placeholder={`Enter Note Date / Time`}
                        label="Note Date / Time"
                        name="noteDate"
                        value={values?.noteDate}
                        onChange={(e) => {
                          setFieldValue(
                            "noteDate",
                            e?.target?.value
                          );
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.noteDate}
                      />
                    </div> */}
                    <div className="col-sm-6 col-xs-6 col-md-3 col-xl-3 form-group start-enddate">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className={` ${classes.labelName} "note-filed"`}
                          format="MM/dd/yyyy"
                          placeholder="MM/DD/YYYY"
                          fullWidth
                          value={values.noteDate}
                          name="noteDate"
                          onBlur={handleBlur}
                          inputVariant="outlined"
                          helperText=""
                          label="Note Date"
                          onChange={(val) => {
                            setFieldValue('noteDate', val);
                          }}
                          autoOk
                          margin="dense"
                          touched={touched?.noteDate}
                          error={Boolean(touched?.noteDate && errors?.noteDate)}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className={`col-md-3 col-lg-3 col-xl-3 form-group`}>
                      <TextField
                        margin="dense"
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Enter Note Text`}
                        label="Note Text"
                        name="noteText"
                        value={values?.noteText}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.noteText}
                        error={Boolean(touched.noteText && errors.noteText)}
                      />
                    </div>

                    <div className={'col-sm-6 col-md-3 col-lg-3 col-xl-3 form-group'}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="createdBy"
                        id="createdBy"
                        size="small"
                        value={values.createdBy}
                        options={createdByData}
                        getOptionLabel={(option) => {
                          return option && option?.userLoginName ? option?.userLoginName : '';
                        }}
                        renderOption={(option) => {
                          return createdByOptions(option);
                        }}
                        onChange={(e, value) => {
                          setFieldValue('createdBy', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Created By"
                              placeholder="Select Created By"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div className={'col-sm-6 col-md-3 col-lg-3 col-xl-3  form-group'}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="noteType"
                        id="noteType"
                        size="small"
                        value={values.noteType}
                        options={noteTypeOptions}
                        getOptionLabel={(option) => {
                          return option && option?.key ? option?.key : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('noteType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Note Type"
                              placeholder="Select NoteType"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-xs-4 col-sm-6 col-md-12 col-lg-12 mb-3">
                      <div className="d-flex justify-content-center">
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn ${classes.buttonRoot}`}
                          onClick={() => {
                            setSearchData(initialValues);
                            setSubmit(true);
                            resetForm(initialValues);
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          variant="outlined"
                          className={`ml-1 search-btn ${classes.buttonRoot}`}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </ErrorBoundaryForComponents>
              </Form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default React.memo(SearchNote);
